import React, { useEffect, useState } from "react";
import { InputGroup } from "react-bootstrap";
import { Link, SliderPanel, FormControlSearch } from "../../../components";
import "../../../styles/containers/CommunicationContainer.scss";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { orderBy } from "@progress/kendo-data-query";

export const CommunicationHistorySlider = ({
  tableData,
  isSliderOpen,
  setSliderOpen,
}) => {
  const [sliderFilteredData, setSliderFilteredData] = useState([]);
  const mappedData = sliderFilteredData?.map((item, idx) => ({
    value: idx,
    label: "E-Mail Address",
    className: "column-emailAddress",
    columnName: "emailAddress",
    email: item,
    width: "auto",
    dataType: "alphaNumeric",
  }));
  useEffect(() => {
    setSliderFilteredData(tableData);
  }, [tableData]);
  return (
    <SliderPanel isOpen={isSliderOpen} size="40" showCancel={false}>
      <div className="mw-810">
        <div className="d-flex mr-600">
          <div
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#000000",
              lineHeight: "21px",
            }}
          >
            Recipient list
          </div>
          <div>
            <Link
              onClick={() => {
                setSliderOpen(false);
              }}
            >
              <i
                class="fal fa-times slidercrossicon"
                style={{ color: "#777777" }}
              ></i>
            </Link>
          </div>
        </div>
        <hr></hr>
        <InputGroup className="communication-search-bar-close">
          {/* <InputGroup.Prepend>
            <div className="search-icon-postion mt-8">
              <i class="fal fa-search" aria-hidden="true"></i>
            </div>
          </InputGroup.Prepend> */}
          <FormControlSearch
            size="md"
            type="search"
            className="plan-search-box pad-left-search"
            placeholder="Search by e-mail id"
            onChange={(e) => {
              setSliderFilteredData(
                tableData.filter((x) =>
                  x.toLowerCase().includes(e.target.value.toLowerCase())
                )
              );
            }}
          />
        </InputGroup>
        <div style={{ marginTop: "60px" }}>
          {/* <Grid
            data={orderBy(sliderFilteredData, sortSlider)}
            total={sliderFilteredData.length}
            resizable={true}
            sortable={true}
            sort={sortSlider}
            onSortChange={(e) => {
              setSliderSort(e.sort);
            }}
            style={{ maxHeight: "600px" }}
            fixedScroll
          >
            {columns.map((column, idx) => {
              return (
                <GridColumn
                  key={idx}
                  field={column.field}
                  width={column.width}
                  title={
                    <div className="grid-column">
                      <div className="ft-14 ftwt-500">{column.label}</div>
                      <i
                        class="fal fa-sort-alpha-down"
                        style={{ marginTop: "2px" }}
                      ></i>
                    </div>
                  }
                  filter={column.dataType}
                  cell={dataCell}
                />
              );
            })}
          </Grid> */}
          <Grid data={mappedData}>
            <GridColumn
              field="email"
              title={
                <div className="grid-column">
                  <div className="ft-14 ftwt-500">E-Mail Address</div>
                </div>
              }
              width="auto"
              className="column-emailAddress"
            />
          </Grid>
        </div>
      </div>
    </SliderPanel>
  );
};
